import React from 'react'
import { Box, Container, Button } from '@mui/material'
import { LinkedIn, Download } from '@mui/icons-material'
import { CONTACT } from '../content/Content'
import { motion } from 'framer-motion'
import { AnimatedText } from '../components/animated/AnimatedComponent'
import { CV } from '../interfaces/File'
import { Colors } from '../constants/Colors'

const ContactPage: React.FC = () => {
   return (
      <Container maxWidth="md" sx={{ mt: 8, mb: 8 }}>
         <Box textAlign="center" sx={{ mb: 6 }}>
            <AnimatedText text={CONTACT.title} type="title" />
            <AnimatedText text={CONTACT.descrption} type="description" delay={0.2} />
         </Box>

         <Box
            textAlign="center"
            sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
         >
            <motion.div
               initial={{ opacity: 0, scale: 0.8 }}
               animate={{ opacity: 1, scale: 1 }}
               transition={{ duration: 0.8, delay: 0.4 }}
            >
               <Button
                  variant="contained"
                  color="primary"
                  href={CONTACT.linkedln}
                  target="_blank"
                  sx={{
                     fontWeight: 'bold',
                     textTransform: 'none',
                     backgroundColor: Colors.NAVY_BLUE,
                     '&:hover': {
                        backgroundColor: Colors.NAVY_BLUE,
                        transform: 'scale(1.05)',
                        transition: 'transform 0.3s ease',
                     },
                  }}
               >
                  <LinkedIn sx={{ marginRight: 1 }} />
                  Connect on LinkedIn
               </Button>
            </motion.div>

            <motion.div
               initial={{ opacity: 0, scale: 0.8 }}
               animate={{ opacity: 1, scale: 1 }}
               transition={{ duration: 0.8, delay: 0.6 }}
            >
               <Button
                  variant="outlined"
                  color="primary"
                  href={CV.href}
                  download={CV.filename}
                  sx={{
                     fontWeight: 'bold',
                     textTransform: 'none',
                     borderColor: Colors.NAVY_BLUE,
                     color: Colors.NAVY_BLUE,
                     '&:hover': {
                        borderColor: Colors.NAVY_BLUE,
                        backgroundColor: Colors.RGBA_NAVY_BLUE,
                        transform: 'scale(1.05)',
                        transition: 'transform 0.3s ease',
                     },
                  }}
               >
                  <Download sx={{ marginRight: 1 }} />
                  Download My CV
               </Button>
            </motion.div>
         </Box>
      </Container>
   )
}

export default ContactPage
